import { Button, Drawer } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { DrawerContentWrapper } from '~/components/drawer-content-wrapper/DrawerContentWrapper';
import { appPaths } from '~/routes/app-paths';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

import { ThemeWidget } from '../ThemeWidget';
import { useThemeDrawer } from './useThemeDrawer';

export const DRAWER_THEME_ID = 'theme';

export interface ThemeDrawerProps {
  entity: Entity;
}

export const ThemeDrawer = ({ entity }: ThemeDrawerProps) => {
  const { t } = useTranslation(['widget']);
  const navigate = useNavigate();
  const { trackThemeOpen } = usePosthogEvents();

  const { closeDrawer, isDrawerOpen, themeId } = useThemeDrawer();

  if (!themeId) {
    return null;
  }

  return (
    <Drawer
      data-testid="theme-drawer"
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        <Button
          variant="empty"
          label={t('widget:themeOverview.drawer.themeOverview')}
          iconName="Expand"
          onClick={() => {
            trackThemeOpen(POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW_DRAWER);
            navigate(`${appPaths.themeOverview}/${themeId}`);
          }}
        />
      }
    >
      <DrawerContentWrapper>
        <ThemeWidget entity={entity} themeId={themeId} />
      </DrawerContentWrapper>
    </Drawer>
  );
};
